
import * as types from '../mutation-types';
import Vue from 'vue'
import {
    code_login, log_out, get_profile, login_by_id,
    update_phone_number
} from "@/api/auth"
const fb = require("@/firebase/config.js");
import store from '@/store'
export const state = {
    user: null,
    token: null,
    loading: false,
    check: false,
    codeLoginState: false,
    codeChecked: false,
    place_by_code_activated: {},
    firebase_init: false,
    redirect: false,
    loadingUpdateUser: false,



}
export const getters = {
    loadingUpdateUser: state => state.loadingUpdateUser,
    redirect: state => state.redirect,
    user: state => state.user,
    token: state => state.token,
    check: state => state.check,
    loading: state => state.loading,
    codeLoginState: state => state.codeLoginState,
    codeChecked: state => state.codeChecked,
    firebase_init: state => state.firebase_init,
    place_by_code_activated: state => state.place_by_code_activated,
}

export const mutations = {
    [types.REDIRECT](state, payload) {
        state.redirect = payload;
    },
    [types.FIRE_BASE_INIT](state, payload) {
        state.firebase_init = payload;
    },
    [types.CODE_CHECKED](state, payload) {
        state.codeChecked = payload;
    },
    [types.USER](state, payload) {
        state.loading = true;
    },
    [types.USER_FAIL](state, payload) {
        state.loading = false;
        state.user = null;
        state.check = false;
    },
    [types.USER_SUCCESS](state, payload) {
        state.loading = false;
        state.check = true;
        state.user = payload;
    },
    [types.LOGIN](state, payload) {
        state.loading = true;
    },
    [types.LOGIN_FAIL](state, payload) {
        state.loading = false;
        state.token = null;
    },
    [types.LOGIN_SUCCESS](state, payload) {
        state.loading = false;
        state.token = payload;
    },
    [types.SAVE_TOKEN](state, payload) {
        state.loading = false;
        state.token = payload;
        state.check = true;
    },

    [types.LOGOUT](state, payload) {
        state.loading = false;
    },
    [types.LOGOUT_FAIL](state, payload) {
        state.loading = false;
    },
    [types.LOGOUT_SUCCESS](state, payload) {
        state.firebase_init = false;
        state.loading = false;
        state.token = null;
        state.check = false;
        state.user = null
        state.codeLoginState = false;
        state.codeChecked = false;
        localStorage.removeItem('access_token');
        state.place_by_code_activated = {}
    },
    updateUser(state) {
        state.loadingUpdateUser = true
    },
    updateUserDone(state) {
        state.loadingUpdateUser = false
    },
    updateUserFail(state) {
        state.loadingUpdateUser = false
    },
    updateUserLocal(state, payload){
        state.user.phone = payload
    },
    clearUser(state){
        state.user = null

    }
}
export const actions = {
    clearUser({ commit }){
        commit('clearUser');
    },

    async updatePhoneNumber({ commit, getters }, payload) {
        commit('updateUser');
        try {
            await update_phone_number(payload); 
            commit('updateUserLocal',payload.phone);
            commit('updateUserDone');
        } catch (err) {
            commit('updateUserFail');
            throw err 
        }
    },

    async login({ commit, getters }, payload) {
        commit(types.LOGIN);
        try {
            const respone = await login_by_id(payload);
            commit(types.LOGIN_SUCCESS, respone.access_token);
            commit(types.SAVE_TOKEN, respone.access_token);
            commit(types.USER_SUCCESS, respone.user);
        } catch (err) {
            commit(types.LOGIN_FAIL);

        }
    },
    async getUser({ commit, getters }) {
        commit(types.USER);
        try {
            const data = await get_profile();
            localStorage.setItem('_user', JSON.stringify({ username: data.user.contact_fullname, order: 0 }))
            commit(types.USER_SUCCESS, data.user);
        } catch (err) {
            commit(types.USER_FAIL);
        }
    },
    async saveToken({
        commit
    }, payload) {
        commit(types.SAVE_TOKEN, payload);
    },

    async LogOut({ commit, getters }, payload) {

        commit(types.LOGOUT);
        try {
            if (getters.token) {
                await log_out();
                localStorage.setItem('_user', null)
            }
            commit(types.LOGOUT_SUCCESS);
            commit(types.CODE_CHECKED, false);
            commit(types.FIRE_BASE_INIT, false);
        } catch (error) {
            commit(types.LOGOUT_FAIL);
            commit(types.FIRE_BASE_INIT, false);
        }
    },
    Clear({ commit }, payload) {
        commit(types.LOGOUT_SUCCESS);
    },
    firebaseState({ commit }, payload) {
        commit(types.FIRE_BASE_INIT, payload);
    },
    async firestore_init({ commit, getters }, payload) {
        if (!getters.user) return;
        fb.ordersCollection
            .doc("user_" + getters.user.id)
            .onSnapshot(function (querySnapshot) {
                let data = querySnapshot.data();
                if (!data) return;
                store.dispatch("nav/setPendingNumber", data.count_sale || 0);
                localStorage.setItem('_user', JSON.stringify({ username: getters.user.contact_fullname, order: data.count_sale }))

                if (getters.firebase_init === true) {
                    Vue.notify({
                        group: "order",
                        title: `OrderID: # ${data.order_id} is ${data.status}`,
                        type: "success",
                        speed: 1000
                        // text: `OrderID: # ${data.order_id} is ${data.status}`
                    });
                }
                commit(types.FIRE_BASE_INIT, true);


            });
    },
    setToken({commit}, payload){
        commit(types.SAVE_TOKEN, payload);
    },

}